export const READY_TO_SUBMIT_CHECKBOX = {
    SELECT_ALL: "selectAllCheckBox",
    USPS_MAIL: "uspsMailCheckbox",
    EMAIL_RECIPIENT: "emailRecipientCheckbox",
    TIN_MATCH: "tinMatchCheckbox",
    STATE_FILING: "stateFilingCheckbox",
}

export const LOAD_FORMS_DATA_STATE = {
    SINGLE: "SINGLE",
    MULTIPLE: "MULTIPLE",
    CALCULATE_TAX_1099_FEE: "CALCULATE_TAX_1099_FEE"
}

export const FORM_LISTING_LOADING_STATES = {
    FETCHING_FORMS_LIST_LOADING: "FETCHING_FORMS_LIST_LOADING",
    FETCHING_FORMS_LIST_READY: "FETCHING_FORMS_LIST_READY",
    FETCHING_TAX_YEARS_LOADING: "FETCHING_TAX_YEARS_LOADING",
    FETCHING_TAX_YEARS_READY: "FETCHING_TAX_YEARS_READY",
    FETCHING_PAYERS_LOADING: "FETCHING_PAYERS_LOADING",
    FETCHING_PAYERS_READY: "FETCHING_PAYERS_READY",
    FETCHING_FORM_LIST_LOADING: "FETCHING_FORM_LIST_LOADING",
    FETCHING_FORM_LIST_READY: "FETCHING_FORM_LIST_READY",
    DELETE_BULK_FORM_LOADING: "DELETE_BULK_FORM_LOADING",
    DELETE_BULK_FORM_READY: "DELETE_BULK_FORM_READY",
    DELETE_BULK_FORM_FROM_DRAWER_LOADING: "DELETE_BULK_FORM_FROM_DRAWER_LOADING",
    DELETE_BULK_FORM_FROM_DRAWER_READY: "DELETE_BULK_FORM_FROM_DRAWER_READY",
    DELETE_SINGLE_FORM_LOADING: "DELETE_SINGLE_FORM_LOADING",
    DELETE_SINGLE_FORM_READY: "DELETE_SINGLE_FORM_READY",
    DELETE_SINGLE_FORM_FROM_DRAWER_LOADING: "DELETE_SINGLE_FORM_FROM_DRAWER_LOADING",
    DELETE_SINGLE_FORM_FROM_DRAWER_READY: "DELETE_SINGLE_FORM_FROM_DRAWER_READY",
    GET_FORM_DETAILS_LOADING: "GET_FORM_DETAILS_LOADING",
    GET_FORM_DETAILS_READY: "GET_FORM_DETAILS_READY",
    CREATE_ZIP_LOADING: "CREATE_ZIP_LOADING",
    CREATE_ZIP_READY: "CREATE_ZIP_READY",
    DOWNLOAD_MULTIPLE_PDF_LOADING: "DOWNLOAD_MULTIPLE_PDF_LOADING",
    DOWNLOAD_MULTIPLE_PDF_READY: "DOWNLOAD_MULTIPLE_PDF_READY",
    DOWNLOAD_SINGLE_PDF_LOADING: "DOWNLOAD_SINGLE_PDF_LOADING",
    DOWNLOAD_SINGLE_PDF_READY: "DOWNLOAD_SINGLE_PDF_READY",
    EXPORT_TO_EXCEL_LOADING: "EXPORT_TO_EXCEL_LOADING",
    EXPORT_TO_EXCEL_READY: "EXPORT_TO_EXCEL_READY",
    SUBMIT_FOR_THIS_PAYER_LOADING: "SUBMIT_FOR_THIS_PAYER_LOADING",
    SUBMIT_FOR_THIS_PAYER_READY: "SUBMIT_FOR_THIS_PAYER_READY",
    SUBMIT_FOR_THIS_PAYER_FROM_DRAWER_LOADING: "SUBMIT_FOR_THIS_PAYER_FROM_DRAWER_LOADING",
    SUBMIT_FOR_THIS_PAYER_FROM_DRAWER_READY: "SUBMIT_FOR_THIS_PAYER_FROM_DRAWER_READY",
    FETCHING_LOAD_FORMS_DATA_FROM_DRAWER_LOADING: "FETCHING_LOAD_FORMS_DATA_FROM_DRAWER_LOADING",
    FETCHING_LOAD_FORMS_DATA_FROM_DRAWER_READY: "FETCHING_LOAD_FORMS_DATA_FROM_DRAWER_READY",
    FETCHING_LOAD_FORMS_DATA_LOADING: "FETCHING_LOAD_FORMS_DATA_LOADING",
    FETCHING_LOAD_FORMS_DATA_READY: "FETCHING_LOAD_FORMS_DATA_READY",
    CALCULATE_FEE_AMOUNT_LOADING: "CALCULATE_FEE_AMOUNT_LOADING",
    CALCULATE_FEE_AMOUNT_READY: "CALCULATE_FEE_AMOUNT_READY",
    CALCULATE_FEE_AMOUNT__FROM_DRAWER_LOADING: "CALCULATE_FEE_AMOUNT_LOADING",
    CALCULATE_FEE_AMOUNT_FROM_DRAWER_READY: "CALCULATE_FEE_AMOUNT_READY",
    GET_CHANGE_SCHEDULE_DATE_STATUS_LOADING: "GET_CHANGE_SCHEDULE_DATE_STATUS_LOADING",
    GET_CHANGE_SCHEDULE_DATE_STATUS_READY: "GET_CHANGE_SCHEDULE_DATE_STATUS_READY",
    FETCHING_STATE_LIST_LOADING: "FETCHING_STATE_LIST_LOADING",
    FETCHING_STATE_LIST_READY: "FETCHING_STATE_LIST_READY",
    FETCHING_STATUS_LOADING: "FETCHING_STATUS_LOADING",
    FETCHING_STATUS_READY: "FETCHING_STATUS_READY"
}

export const FORM_LISTING_MESSAGE_MAP = {
    [FORM_LISTING_LOADING_STATES.FETCHING_FORMS_LIST_LOADING]: "",
    [FORM_LISTING_LOADING_STATES.FETCHING_TAX_YEARS_LOADING]: "",
    [FORM_LISTING_LOADING_STATES.FETCHING_PAYERS_LOADING]: "",
    [FORM_LISTING_LOADING_STATES.FETCHING_FORM_LIST_LOADING]: "",
    [FORM_LISTING_LOADING_STATES.EXPORT_TO_EXCEL_LOADING]: "",
    [FORM_LISTING_LOADING_STATES.FETCHING_LOAD_FORMS_DATA_FROM_DRAWER_LOADING]: "",
    [FORM_LISTING_LOADING_STATES.FETCHING_STATE_LIST_LOADING]: "",
    [FORM_LISTING_LOADING_STATES.FETCHING_STATUS_LOADING]: ""
}

export const IMPORTANT_FIELD_NAMES = {
    PAYER_ID: 'PayerID',
    PAYEE_ID: 'PayeeID',
}

export const CHANGE_PAYER_LABEL_IN_FORMS = {
    "Form1042": "Withholding Agent"
}

export const FORM_NAMS = {
    $1099_NEC: "1099-NEC",
    STATEPAYROLL: "Payroll"
}


export const EFILE_DEADLINE_DATE = "01/31/24"

export const TAB_PATHS = {
    LISTING: "form1099",
    STATEPAYROLL: "statepayroll"
}

export const QUERY_PARAMS_VALUES = {
    STATENAME: "StateName",
    FORM_ID: "FormId",
    TAX_YEAR: "ID",
    PAYER_ID: "PayerDetailId"
}